import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UnidadInspeccionService } from './unidad-inspeccion.service';
import { RegistrosModule } from '../../_mantenimiento/registros/registros.module';
import { RecintoModule } from '../recintos/recinto.module';
import { UnidadesInspeccionRoutingModule } from './unidades-inspeccion-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppModuleGlobalShared } from 'src/app/app.module.global';
import { CoreModule } from '../../core/core.module';
import { UnidadInspeccionWrapperComponent } from './datos-basicos/unidad-inspeccion-wrapper/unidad-inspeccion-wrapper.component';
import { UnidadInspeccionListComponent } from './datos-basicos/unidad-inspeccion-list/unidad-inspeccion-list.component';
import { UnidadInspeccionHeaderComponent } from './datos-basicos/unidad-inspeccion-header/unidad-inspeccion-header.component';
import { SelectorUnidadInspeccionFilterComponent } from './selector/selector-unidad-inspeccion-filter/selector-unidad-inspeccion-filter.component';
import { SelectorUnidadInspeccionListComponent } from './selector/selector-unidad-inspeccion-list/selector-unidad-inspeccion-list.component';
import { SelectorUnidadInspeccionWrapperComponent } from './selector/selector-unidad-inspeccion-wrapper/selector-unidad-inspeccion-wrapper.component';
import { SelectorUnidadInspeccionSuperficieComponent } from './selector/selector-unidad-inspeccion-superficie/selector-unidad-inspeccion-superficie.component';
import { GeneralModule } from '../../_mantenimiento/general/general.module';
import { InspeccionUiEditComponent } from './inspecciones/inspeccion-ui-edit/inspeccion-ui-edit.component';
import { InspeccionUiWrapperEditComponent } from './inspecciones/inspeccion-ui-wrapper-edit/inspeccion-ui-wrapper-edit.component';
import { InspeccionUiWrapperComponent } from './inspecciones/inspeccion-ui-wrapper/inspeccion-ui-wrapper.component';
import { InspeccionUiListComponent } from './inspecciones/inspeccion-ui-list/inspeccion-ui-list.component';
import { DocumentoUiWrapperComponent } from './documentos/documento-ui-wrapper/documento-ui-wrapper.component';
import { DocumentoUiListComponent } from './documentos/documento-ui-list/documento-ui-list.component';
import { DocumentoUiWrapperEditComponent } from './documentos/documento-ui-wrapper-edit/documento-ui-wrapper-edit.component';
import { DocumentoUiEditComponent } from './documentos/documento-ui-edit/documento-ui-edit.component';
import { ComentarioUiWrapperComponent } from './comentarios/comentario-ui-wrapper/comentario-ui-wrapper.component';
import { ComentarioUiListComponent } from './comentarios/comentario-ui-list/comentario-ui-list.component';
import { ComentarioUiWrapperEditComponent } from './comentarios/comentario-ui-wrapper-edit/comentario-ui-wrapper-edit.component';
import { ComentarioUiEditComponent } from './comentarios/comentario-ui-edit/comentario-ui-edit.component';
import { InspeccionUiService } from './inspeccion-ui.service';
import { InspeccionUiPeriodoListComponent } from './inspecciones/inspeccion-ui-periodo-list/inspeccion-ui-periodo-list.component';
import { InspeccionUiAforoCorteListComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-list/inspeccion-ui-aforo-corte-list.component';
import { InspeccionUiAforoCorteEditComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-edit/inspeccion-ui-aforo-corte-edit.component';
import { InspeccionUiAforoCorteWrapperEditComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-wrapper-edit/inspeccion-ui-aforo-corte-wrapper-edit.component';
import { ComentarioUiService } from './comentario-ui.service';
import { InspeccionUiAforoCorteWrapperComponent } from './aforos-y-cortes/inspeccion-ui-aforo-corte-wrapper/inspeccion-ui-aforo-corte-wrapper.component';
import { AforoCultivoCamService } from './aforo-cultivo.service';
import { DocumentoUiService } from './documento-ui.service';
import { CorteCultivoCamService } from './corte-cultivo.service';

@NgModule({
    declarations: [
        SelectorUnidadInspeccionWrapperComponent,
        SelectorUnidadInspeccionListComponent,
        SelectorUnidadInspeccionFilterComponent,
        UnidadInspeccionWrapperComponent,
        UnidadInspeccionListComponent,
        UnidadInspeccionHeaderComponent,
        SelectorUnidadInspeccionSuperficieComponent,
        InspeccionUiEditComponent,
        InspeccionUiWrapperEditComponent,
        InspeccionUiWrapperComponent,
        InspeccionUiListComponent,
        DocumentoUiWrapperComponent,
        DocumentoUiListComponent,
        DocumentoUiWrapperEditComponent,
        DocumentoUiEditComponent,
        ComentarioUiWrapperComponent,
        ComentarioUiListComponent,
        ComentarioUiWrapperEditComponent,
        ComentarioUiEditComponent,
        InspeccionUiPeriodoListComponent,
        InspeccionUiAforoCorteListComponent,
        InspeccionUiAforoCorteEditComponent,
        InspeccionUiAforoCorteWrapperEditComponent,
        InspeccionUiAforoCorteWrapperComponent,
    ],
    exports: [],
    imports: [
        GeneralModule, // Componentes empresas-deshidratadoras
        RegistrosModule, // Componentes codigo-confeccion (almacén)
        RecintoModule, // Componentes recintos
        CoreModule, // Componente Dialog, GlobalService, CampaniasService, DocumentUploader, MessageService, AuthService, y demás módulos y componentes compartidos.
        AppModuleGlobalShared, // Pipes y componentes de PrimeNg, CoreUI o demás de formularios
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UnidadesInspeccionRoutingModule,
        RouterModule.forRoot([], { bindToComponentInputs: true }),
    ],
    providers: [UnidadInspeccionService, InspeccionUiService, ComentarioUiService, DocumentoUiService, AforoCultivoCamService, CorteCultivoCamService],
})
export class UnidadesInspeccionModule {}
